import type {IntlShape} from 'react-intl';

import {ChannelFieldInvitationErrorCode} from './invite_members_form/channel_field_invitation_error_code';

export class ChannelFieldInvitationError {
    public readonly code: ChannelFieldInvitationErrorCode;

    constructor(code: ChannelFieldInvitationErrorCode) {
        this.code = code;
    }

    getLocalizedMessage(intl: IntlShape) {
        switch (this.code) {
        case ChannelFieldInvitationErrorCode.API_ARCHIVED_CHANNELS_FOUND:
            return intl.formatMessage({
                id: 'invite.members.error.channels_some_archived',
                defaultMessage: 'The channel has been archived, we will not be able to invite a new member to it',
            });
        }

        return '';
    }
}
